import { LOAD_CARDS, ADD_CARD, REMOVE_CARD } from "../actions";

import { Card } from "../types";

export type CardsState = typeof initialState;

export const initialState = {
	cards: [] as Card[],
	defaultCard: null as Card,
};

function findDefaultCard(cards: Card[]): Card | null {
	for (let card of cards) {
		if (card.default) {
			return card;
		}
	}

	if (Array.isArray(cards) && cards.length >= 1) {
		return cards[0];
	}

	return null;
}

export default function(state: CardsState = initialState, action) {
	switch (action.type) {
		case LOAD_CARDS: {
			const { cards } = action;
			if (!cards) {
				return state;
			}
			const defaultCard = findDefaultCard(cards);

			return { ...state, cards, defaultCard };
		}

		case ADD_CARD: {
			const { card } = action;
			let { cards } = state;

			cards = [...cards.concat(card)];
			const defaultCard = findDefaultCard(cards);

			return { ...state, cards, defaultCard };
		}

		case REMOVE_CARD: {
			const { id } = action;
			let { cards } = state;

			cards = cards.filter(card => card.cardId !== id);
			const defaultCard = findDefaultCard(cards);

			return { ...state, cards, defaultCard };
		}

		default:
			return state;
	}
}
